import React from 'react'
import styled from 'styled-components'
import Container from 'components/Container'

const Page = ({ children }) => (
  <StyledPage>
    <StyledMain>{children}</StyledMain>
    <Container size="lg">
      <p>You Bet! Launch provides the service that allows eligible entities to
              create their own token sales. It is such entity's own responsibility
              to know whether you are eligible to run it. Unfortunately, since
              our service is fully decentralized, the technology is not
              available for You Bet! to help you find out whether you are
              eligible. We are not responsible for pool owner's behavior.{' '}</p>
    </Container>
  </StyledPage>
)

const StyledPage = styled.div``

const StyledMain = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;
  min-height: calc(100vh - ${(props) => props.theme.topBarSize * 2}px);
`

export default Page
